var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"r-main-bottom--standard"},[_c('iframe',{staticStyle:{"height":"600px"},attrs:{"id":"jks-iframe","src":_vm.originUrl,"frameborder":"0","align":"left","scrolling":"no","width":"100%","name":"JKS"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f971ba2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Iframe.vue
// module id = 442
// module chunks = 0